import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import Keycloak from 'keycloak-js';

const allowedRealmRoles = new Set([
    'APP_P_GATE_ADMIN',
    'APP_P_GATE_OPERATOR',
]);

const getRealmRoles = (keycloak: Keycloak): string[] => {
    const roles =
        keycloak.realmAccess?.roles ?? keycloak.tokenParsed?.realm_access?.roles;

    return Array.isArray(roles) ? roles : [];
};

export const realmRoleGuard: CanActivateFn = () => {
    const keycloak = inject(Keycloak);
    const router = inject(Router);

    const roles = getRealmRoles(keycloak);
    const hasRequiredRole = roles.some((role) => allowedRealmRoles.has(role));

    return hasRequiredRole ? true : router.createUrlTree(['/unauthorized']);
};
